import OperationalModal from './OperationalModal.vue';

export default OperationalModal;
